import React from "react";

import PageHeader from "../Components/PageHeader";
import PurposeSection from "./Home/PurposeSection";
import CounterSection from "./Home/CounterSection";
import PrintGallerySection from "./Home/PrintGallerySection";
import ClientRateSection from "./Home/ClientRateSection";
import ContactSection from './Home/ContactSection';
import MeetTheTeamSection from './AboutUs/MeetTheTeam';


const About = () => {

    return (
        <>
            <PageHeader pageKey="about" />
            <PurposeSection imageBottom={true} />
            <CounterSection />
            <PrintGallerySection />
            <ClientRateSection />
            <ContactSection />
            <MeetTheTeamSection />
        </>
    );
};

export default About;